// extracted by mini-css-extract-plugin
export default {"whole":"summary_whole__lfnQ5","title":"summary_title__lvKXt","row":"summary_row__tOo+N","caption":"summary_caption__fXrZt","top":"summary_top__ZepPi","name":"summary_name__kFFow"};